import { deleteAdminProgram } from '../../../shared/api/programs.services';
import toast from '../../../shared/lib/toast';

// Раніше картка й контент програми редагувались на двох різних екранах, і
// половина полів сторінки не було ніде. Тепер усе на одному екрані.
export const patchClick = (id, navigate) => {
  navigate(`/programs-content-edit/${id}`);
};

export const deleteProgramClick = async (programId, onSuccessRefresh) => {
  if (window.confirm('Ви впевнені, що хочете видалити цю програму?')) {
    const response = await deleteAdminProgram(programId);

    if (response?.ok || !response?.error) {
      if (onSuccessRefresh) onSuccessRefresh();
      toast.success('Програму успішно видалено!');
    } else {
      toast.error(response?.message || 'Помилка при видаленні програми.');
    }
  }
};
